module.exports = __webpack_public_path__ + "img/social-2.62dcc163.png";